/**
 * Origine publique du front (callbacks Stripe, portail client, etc.).
 * En général laisser `VITE_PUBLIC_SITE_URL` vide : l’app utilise `window.location` (localhost, *.web.app, domaine custom).
 * À renseigner seulement pour tunnel/ngrok ou reverse proxy où l’origine publique diffère du navigateur.
 */
export function getSiteOrigin(): string {
  const raw = import.meta.env.VITE_PUBLIC_SITE_URL?.trim()
  if (raw) {
    try {
      const u = new URL(raw.includes('://') ? raw : `https://${raw}`)
      return u.origin
    } catch {
      /* ignore */
    }
  }
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
}

/**
 * URL complète de la page courante, avec l’origine issue de l’env si elle est définie (pour `return_url` Stripe).
 */
export function getPublicPageUrl(): string {
  const origin = getSiteOrigin()
  if (typeof window === 'undefined') {
    return origin
  }
  return `${origin}${window.location.pathname}${window.location.search}`
}
